import { publishableKeyFromHost } from "@clerk/react/internal";

export function resolveWebClerkConfig(
  hostname: string,
  fallbackPublishableKey: string | undefined,
  proxyUrl: string | undefined,
) {
  const publishableKey = publishableKeyFromHost(hostname, fallbackPublishableKey);
  if (!publishableKey) {
    throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY");
  }

  return {
    publishableKey,
    proxyUrl,
  };
}

export const clerkWebConfig = resolveWebClerkConfig(
  window.location.hostname,
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  import.meta.env.VITE_CLERK_PROXY_URL,
);